module.exports = __webpack_public_path__ + "img/header.5ba35692.png";